import { createFileRoute } from "@tanstack/react-router";
import { ButtonExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/foundations/buttons")(
  {
    component: ButtonExamples,
  },
);
